<template>
    <div>     
      <div class="go-top">
          <div class="foc">关注我们</div>
      </div>

      <!-- <div class="dong"> -->
        <div class="go-tops">
          <div class="fo">
            <div class="focs">关注我们</div>
            <div class="twowm">
                <div class="fl ewm1">
                    <div class="imew"><img src="@/assets/u0.jpg" alt=""></div>
                    <p>藤蔓计划</p>
                </div>
                <div class="fr ewm2">
                    <div class="imew"><img src="@/assets/u0.jpg" alt=""></div>
                    <p>微信公众号</p>
                </div>
            </div>
          </div>
      </div>
      <!-- </div> -->
    </div>
</template>
<script>
export default {
    data(){
        return{
            btnFlag:true,
        }
    },
    
    mounted () {
    //   window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed () {
    //   window.removeEventListener('scroll', this.scrollToTop)
    },
    
    
    methods: {

    }

}
</script>
<style scoped>
.go-top{
  position: fixed;
  bottom: 50%;
  margin-bottom: -2.3625rem;
  right: 0px;
  width: 1.075rem;
  height: 4.725rem;
  cursor: pointer;
  background: #0A4AA1;
  box-shadow:0px .1rem .2rem 0px rgba(1,10,23,0.5);
  border-radius: .2rem 0 0 .2rem;
  z-index: 99;
}
.foc{
    width: .45rem;
    height: 3rem;
    font-size: .45rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(255,255,255,1);
    line-height: .75rem;
    position: absolute;
    right: 0;
    margin-right: .25rem;
    box-sizing: border-box;
    top: 50%;
    margin-top: -1.5rem;
}
.dong{
    position: fixed;
    bottom: 50%;
    margin-bottom: -2.3625rem;
    right: 0px;
    width: 1.075rem;
    height: 4.725rem;
    cursor: pointer;
    background: #0A4AA1;
    box-shadow:0px .1rem .2rem 0px rgba(1,10,23,0.5);
    border-radius: .2rem 0 0 .2rem;
    z-index: 99;
}
.go-tops{
  position: fixed;
  bottom: 50%;
  margin-bottom: -2.3625rem;
  right: 0px;
  width: 6.6rem;
  height: 4.725rem;
  cursor: pointer;
  background: #0A4AA1;
  box-shadow:0px .1rem .2rem 0px rgba(1,10,23,0.5);
  border-radius: .2rem 0 0 .2rem;
  z-index: -1;
  color: #ffffff;
}
.fo{
  width: 90%;
  height: 100%;
  position: absolute;
  /* background: aquamarine; */
  left: 50%;
  margin-left: -45%;
}
.focs{
    width: 10%;
    height: 3rem;
    font-size: .45rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    /* color: rgba(255,255,255,1); */
    line-height: .75rem;
    position: absolute;
    left: 0;
    box-sizing: border-box;
    top: 50%;
    margin-top: -1.5rem;
}
.twowm{
    width: 90%;
    /* background: antiquewhite; */
    height: 70%;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -25%;
}
.ewm1{
    width: 50%;
    /* background: wheat; */
    height: 100%;
}
.imew{
    width: 85%;
    height: 70%;
    margin: auto;
}
.ewm1 img,.ewm2 img{
    width: 100%;
    height: 100%;
    margin: auto;
    display: block;
}
.ewm1 p,.ewm2 p{
    font-size: .4rem;
    width: 100%;
    text-align: center;
    line-height: 1rem;
}
.ewm2{
    width: 50%;
    height: 100%;
}
.go-top:hover{
    display: none;
}
.go-top:hover + .go-tops{
    z-index: 100;
}
</style>


// WEBPACK FOOTER //
// src/components/Focus.vue